package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StudentSubjectEnrollmentResponse(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("class_subject_link_id") val classSubjectLinkId: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    val id: String? = null
)
